console.log("utils.js added")
import moment from "moment";
// utils.js
export default {
  install(Vue) {
        Vue.prototype.$saludar =()=>{
            return 'jojojo'
        }

        // FORMATO
        
        Vue.prototype.$formatear_fecha =(fecha,formato)=>{
          return moment(fecha).format(formato)
        }
        Vue.prototype.$ahora=()=>{
          return moment();
        }
        Vue.prototype.$pasar_a_segundos= function(tiempo){
          let [hora, minutos, segundos] = tiempo.split(':').map(Number);
          // console.log("Pasando a segundos ",segundos)
          if (segundos==undefined)segundos=0;
          const totalSegundos = hora * 3600 + minutos * 60 + segundos
          return totalSegundos
        }
        Vue.prototype.$pasar_a_minutos =  function (tiempo){
          const [hora, minutos,segundos] = tiempo.split(':').map(Number);
          const totalMinutos = hora * 60 + minutos;
          return totalMinutos;
        };
        
        Vue.prototype.$strpad = function(str,len,prefijo) {
          if(str===undefined)return '';
          let res = str.toString();
          //console.log(res,len,res.length)
          while (res.length < len) {
            res = "0" + res;
            //console.log('res ahora',res)
          }
          res = `${prefijo}${res}`
          return res;
        };
        
        Vue.prototype.$deepCopy = function(obj) {
          if (typeof obj !== 'object' || obj === null) {
            return obj; // Devuelve valores no objetos directamente
          }
        
          const copiedObj = Array.isArray(obj) ? [] : {}; // Crea una nueva instancia del objeto
        
          for (let key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              // Realiza una copia profunda de cada propiedad del objeto
              copiedObj[key] = this.$deepCopy(obj[key]);
            }
          }
          
          return copiedObj;
        }
        
        // RESTAS
        Vue.prototype.$diferencia_tiempos_minutos = function(tiempo1, tiempo2) {
          // Convertir las horas y minutos a minutos
          const totalMinutos1 = Vue.prototype.$pasar_a_minutos(tiempo1);
          const totalMinutos2 = Vue.prototype.$pasar_a_minutos(tiempo2);
          
          // Calcular la diferencia en minutos
          return Math.abs(totalMinutos1 - totalMinutos2);
        };
        
        Vue.prototype.$diferencia_tiempos=(tiempo1, tiempo2)=>{
           // Separar las horas y minutos de las cadenas de tiempo
           const totalSegundos1 = Vue.prototype.$pasar_a_segundos(tiempo1);
           const totalSegundos2 = Vue.prototype.$pasar_a_segundos(tiempo2);
          // Calcular la diferencia en segundos
          let diferenciaSegundos = Math.abs(totalSegundos1 - totalSegundos2);

          // Calcular las horas, minutos y segundos de la diferencia
          const horasTotales = Math.floor(diferenciaSegundos / 3600);
          const minutosTotales =  Math.floor((diferenciaSegundos % 3600) / 60);
          const segundosTotales = diferenciaSegundos % 60;
          
          return `${String(horasTotales).padStart(2, "0")}:${String(minutosTotales).padStart(2,"0")}:${String(segundosTotales).padStart(2,"0")}`
          // return `${String(horasTotales).padStart(2, "0")}:${String(minutosTotales).padStart(2,"0")}`
         }

        // SUMAS
        Vue.prototype.$sumar_minutos_a_hora=(minutos, hora)=>{
          // Convertir las horas y minutos a minutos
          const totalMinutos1 = Vue.prototype.$pasar_a_minutos(hora);
          const minutos_temp = totalMinutos1+parseInt(minutos)
        
          // Calcular las horas y minutos de la diferencia
          const horas_reales = Math.floor(minutos_temp / 60);
          const minutos_reales = minutos_temp % 60;

          // Devolver la diferencia en formato HH:mm
          return `${String(horas_reales).padStart(2, '0')}:${String(minutos_reales).padStart(2, '0')}`;
        }
        Vue.prototype.$sumar_segundos_a_hora=(segundos, hora)=>{
          // Convertir las horas y minutos a minutos
          const totalSegundos = Vue.prototype.$pasar_a_segundos(hora);
          const suma_segundos = totalSegundos+parseInt(segundos)
          // Calcular las horas y minutos de la diferencia
          const horasTotales = Math.floor(suma_segundos / 3600);
          const minutosTotales =  Math.floor((suma_segundos % 3600) / 60);
          const segundosTotales = suma_segundos % 60;

          // Devolver la diferencia en formato HH:mm
          return `${String(horasTotales).padStart(2, '0')}:${String(minutosTotales).padStart(2, '0')}:${String(segundosTotales).padStart(2,"0")}`
        }

        Vue.prototype.$suma_horas=(tiempo1, tiempo2)=>{
           // Separar las horas y minutos de las cadenas de tiempo
           const totalSegundos1 = Vue.prototype.$pasar_a_segundos(tiempo1);
           const totalSegundos2 = Vue.prototype.$pasar_a_segundos(tiempo2);

 
           // Calcular la diferencia en segundos
           let sumaSegundos = (totalSegundos1 + totalSegundos2);
 
           // Calcular las horas, minutos y segundos de la diferencia
           const horasTotales = Math.floor(sumaSegundos / 3600);
           const minutosTotales =  Math.floor((sumaSegundos % 3600) / 60);
           const segundosTotales = sumaSegundos % 60;
           
           return `${String(horasTotales).padStart(2, "0")}:${String(minutosTotales).padStart(2,"0")}:${String(segundosTotales).padStart(2,"0")}`
        }
        
        

      
      // Puedes añadir más funciones genéricas aquí si es necesario
    }
  };